'use strict';

var toPrimitive = require('es-to-primitive/es2015');

// https://262.ecma-international.org/6.0/#sec-toprimitive

module.exports = function ToPrimitive(input) {
	if (arguments.length > 1) {
		return toPrimitive(input, arguments[1]);
	}
	return toPrimitive(input);
};



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/2022/ToPrimitive.js
// module id = 1098
// module chunks = 0